/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventGroupIndex: NonNullable<unknown> }} Timeline_Track_No_Event_GroupInputs */



/**
* | output |
* | --- |
* | "No event group available at index {eventGroupIndex}" |
*
* @param {Timeline_Track_No_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_track_no_event_group = /** @type {((inputs: Timeline_Track_No_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Track_No_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Aucun groupe d'evenements disponible a l'index ${i?.eventGroupIndex}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Unter dem Index ${i?.eventGroupIndex} ist keine Ereignisgruppe verfügbar.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Nessun gruppo di eventi disponibile all'indice ${i?.eventGroupIndex}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Группа событий по индексу ${i?.eventGroupIndex} недоступна`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No hay ningún grupo de eventos disponible en el índice ${i?.eventGroupIndex}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`索引 ${i?.eventGroupIndex} 处没有可用的事件组`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`インデックス ${i?.eventGroupIndex} で利用可能なイベント グループはありません`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इंडेक्स ${i?.eventGroupIndex} पर कोई इवेंट समूह उपलब्ध नहीं है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Nenhum grupo de eventos disponível no índice ${i?.eventGroupIndex}`)
	return /** @type {LocalizedString} */ (`No event group available at index ${i?.eventGroupIndex}`)
});